const KST_OFFSET_MS = 9 * 60 * 60 * 1000;

// KST 기준 해당 UTC ms의 날짜 자정(00:00:00) UTC ms 반환
function startOfDayKST(utcMs) {
  const kstMs = utcMs + KST_OFFSET_MS;
  const d = new Date(kstMs);
  const y = d.getUTCFullYear();
  const m = d.getUTCMonth();
  const day = d.getUTCDate();
  return Date.UTC(y, m, day) - KST_OFFSET_MS;
}

// "YYYY-MM-DD" → KST 기준 당일 23:59:59.999 UTC ms
function parseDeadline(deadline) {
  if (!deadline) return null;

  const trimmed = String(deadline).trim();
  if (!trimmed) return null;

  const dateOnlyMatch = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (dateOnlyMatch) {
    const [, year, month, day] = dateOnlyMatch.map(Number);
    // KST 23:59:59.999 = UTC 14:59:59.999
    return new Date(Date.UTC(year, month - 1, day, 23, 59, 59, 999) - KST_OFFSET_MS);
  }

  const parsed = new Date(trimmed);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function getDeadlineDayDiff(deadline) {
  const deadlineAt = parseDeadline(deadline);
  if (!deadlineAt) return null;

  const msPerDay = 1000 * 60 * 60 * 24;
  const deadlineDayStart = startOfDayKST(deadlineAt.getTime());
  const todayStart = startOfDayKST(Date.now());

  return Math.round((deadlineDayStart - todayStart) / msPerDay);
}

export function isDeadlineExpired(deadline) {
  const deadlineAt = parseDeadline(deadline);
  if (!deadlineAt) return false;

  return deadlineAt.getTime() < Date.now();
}

export function isDeadlineClosing(deadline, thresholdDays = 3) {
  const diff = getDeadlineDayDiff(deadline);
  if (diff == null) return false;

  return diff >= 0 && diff <= thresholdDays;
}

export function formatCastingDDay(deadline, { closedLabel = '마감', todayLabel = 'D-Day', expiredPrefix = null } = {}) {
  const diff = getDeadlineDayDiff(deadline);
  if (diff == null) return '';
  if (diff < 0) return expiredPrefix ? `${expiredPrefix}${Math.abs(diff)}` : closedLabel;
  if (diff === 0) return todayLabel;
  return `D-${diff}`;
}
